import CountryRegionData from '@utils/constants/country.json'
import { Dropdown } from 'primereact/dropdown'
import { createElement } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * PrimeReact Dropdown preconfigured with the ISO country/region list, a translated placeholder,
 * and fixed panel styling. Any prop is forwarded to the underlying Dropdown (e.g. value, onChange).
 *
 * @component
 * @param {Object} props - Props forwarded to PrimeReact's Dropdown (value, onChange, showClear, ...).
 * @returns {React.JSX.Element}
 */
export default function CountryDropdown(props) {
  const { t } = useTranslation()

  /**
   * Builds the props forwarded to the underlying PrimeReact Dropdown: the incoming props
   * merged with the country/region option list, translated placeholder, and panel styling.
   *
   * @returns {Object} Props to spread onto the PrimeReact Dropdown.
   */
  const options = () => {
    return {
      ...props,
      options: CountryRegionData,
      optionLabel: 'name',
      optionValue: 'code',
      placeholder: t('common.select_a_country'),
      pt: {
        panel: {
          className: 'border-round border-1 border-solid',
          style: { borderColor: '#ced4da' }
        }
      }
    }
  }

  return createElement(Dropdown, options())
}

CountryDropdown.displayName = 'CountryDropdown'
